module.exports = __webpack_public_path__ + "static/img/luo.377241b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/luo.png
// module id = 89
// module chunks = 1